import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import http from '../utils/http';



//TODO refactor this to use location
export interface Address {
    street: string | null;
    pobox: string | null;
    zip: string | null;
    city: City | null;
}

export interface EntityAddress {
    entityCode: string;
    address: Address;
}

export interface City {
    name: string | null;
    code: string | null;
    parent: County | null;
}

export interface County {
    name: string | null;
    code: string | null;
    parent: State | null;
}

export interface State {
    name: string | null;
    code: string | null;
    parent: Country | null;
}

export interface Country {
    name: string | null;
    code: string | null;
}

export interface Location {
    name: string;
    code: string;
    level: string;
    children: Location[]
}

export interface AddressInput {
    street: string;
    pobox: string;
    cityId: string;
    zip: string;
}

export interface GeoLocation {
    city: City | null;
}

export interface EntityGeoLocation {
    code: string;
    name: string;
    address: GeoLocation | null;
    servesInCounties: Array<County> | null;
}

export interface CountyPopulation {
    code: string;
    populationSize: number;
}

export interface AddressState {
    locations: Array<Location>;
    status: 'idle' | 'loading' | 'failed';
}

const initialState: AddressState = {
    locations: new Array<Location>(),
    status: "idle"
}

export const getAllAddresses = createAsyncThunk(
    "Address/GetAllAddresses",
    async (): Promise<Array<Location>> => {
        try {
            const result = await http<undefined, Array<Location>>({
                path: `/entity/entityAddresses`,
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return new Array<Location>();
            }
        } catch (ex) {
            return new Array<Location>();
        }
    });

export const saveEntityAddress = createAsyncThunk(
    "Address/SaveEntityAddress",
    async (newAddress: EntityAddress): Promise<Address | null> => {
        try {
            const result = await http<EntityAddress, Address>({
                path: `/entity/saveEntityAddress`,
                method: 'post',
                body: newAddress
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

export const getEntityGeoLocations = createAsyncThunk(
    "Address/GetEntityGeoLocations",
    async (): Promise<Array<EntityGeoLocation> | null> => {
        try {
            const result = await http<null, EntityGeoLocation[]>({
                path: `/entity/getEntityGeoLocations`,
                method: 'get',
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (ex) {
            return null;
        }
    });

export const getCountyPopulations = createAsyncThunk(
    "Address/GetCountyPopulations",
    async (): Promise<Array<CountyPopulation> | null> => {
        try {
            const result = await http<null, CountyPopulation[]>({
                path: `/entity/getCountyPopulations`,
                method: 'get',
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return null;
            }
        } catch (e) {
            return null;
        }
    });

export const convertAddressToAddressInput = (address: Address | null): AddressInput | null =>{
    let result: AddressInput | null = null;
    if (address) {
        let convertedAddressInput: AddressInput = {
            street: address.street ? address.street : "",
            pobox: address.pobox ? address.pobox : "",
            cityId: address && address.city && address.city.code ? address.city.code : "",
            zip: address.zip ? address.zip : ""
        };
        result = convertedAddressInput;
    }
    return result;
}


export const addressSlice = createSlice({
    name: 'Address',
    initialState,
    reducers: {
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(getAllAddresses.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getAllAddresses.fulfilled, (state: any, action: any) => {
                state.locations = action.payload;
                state.status = "idle";
            })
            .addCase(saveEntityAddress.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(saveEntityAddress.fulfilled, (state: any, action: any) => {
                state.status = "idle";
            })
            .addCase(getEntityGeoLocations.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getEntityGeoLocations.fulfilled, (state: any, action: any) => {
                state.status = "idle";
            })
            .addCase(getCountyPopulations.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getCountyPopulations.fulfilled, (state: any, action: any) => {
                state.status = "idle";
            });
    },
});

export const { } = addressSlice.actions;

export const selectLocations = (state: RootState) => state.addresses.locations;


export default addressSlice.reducer;